export default __webpack_public_path__ + "e79d31aab3da2d5d615cd74573875de3.png";